"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonpos = exports.getLocation = exports.getAstByString = exports.getAstByObject = void 0;
const parse_1 = require("./lib/parse");
Object.defineProperty(exports, "getAstByObject", { enumerable: true, get: function () { return parse_1.getAstByObject; } });
Object.defineProperty(exports, "getAstByString", { enumerable: true, get: function () { return parse_1.getAstByString; } });
const location_1 = require("./lib/location");
Object.defineProperty(exports, "getLocation", { enumerable: true, get: function () { return location_1.getLocation; } });
function jsonpos(json, options) {
    return location_1.getLocation(typeof json === 'string'
        ? parse_1.getAstByString(json)
        : parse_1.getAstByObject(json), options);
}
exports.jsonpos = jsonpos;
